import { Box, Grid, useTheme } from "@mui/material";
import {
	EnhancedCheckboxRHF,
	ExtensionNumberRHF,
	PhoneNumberRHF,
	RHookFormTextFieldWithLabel,
	SinNumberRHF,
} from "@websential/cosmic-v20";

import { FC } from "react";

interface INewAcocuntIssuerInfoSetupFieldsPanel {
	formMethods: any
}
export const NewAcocuntIssuerInfoSetupFieldsPanel: FC<
	INewAcocuntIssuerInfoSetupFieldsPanel
> = ({
	formMethods
}) => {
		const theme = useTheme();
		const onNonResidentSelectionChangeHandler = (e: any) => {
			if (e) {
				formMethods.clearErrors("ownerSin1")
			}
		}
		return (
			<Box>
				<RHookFormTextFieldWithLabel
					label="First Name"
					id="firstName"
					testId={`name`}
				/>
				<RHookFormTextFieldWithLabel
					label="Last Name"
					id="lastName"
					testId={`name`}
				/>
				<EnhancedCheckboxRHF
					name="nonResident"
					checked={false}
					testId="non-resident"
					checkboxLabel="Non-Resident"
					onSelectionChangeHandler={onNonResidentSelectionChangeHandler}
				/>
				<SinNumberRHF
					label="SIN"
					id="ownerSin1"
					testId={`owner-sin-1`}
				/>
				<Grid
					container
					columnSpacing={0}
					size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				>
					<Grid size={{ xs: 8, sm: 8, md: 8, lg: 8, xl: 8 }}>
						<PhoneNumberRHF
							label="Phone"
							id="phone1"
							testId={`phone`}
						/>
					</Grid>
					<Grid
						size={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}
					></Grid>
					<Grid size={{ xs: 3, sm: 3, md: 3, lg: 3, xl: 3 }}>
						<ExtensionNumberRHF
							label="Ext."
							id="ext"
							testId={`ext`}
						/>
					</Grid>
				</Grid>
			</Box>
		);
	};
